<template>
  <div class="row">
    <div :class="'col-md-' + (layout || '12')">
      <b-form-group :label="startName" :state="state" :class="group_class">
        <date-range-picker
          ref="picker"
          :locale-data="localeData"
          show-dropdowns
          :ranges="false"
          singleDatePicker
          v-model="start_Date"
          :minDate="
            future ? new Date(new Date().getTime() - 24 * 60 * 60 * 1000) : null
          "
          :maxDate="future ? null : new Date(new Date().getTime())"
          autoApply
        >
        </date-range-picker>
      </b-form-group>
    </div>
    <div :class="'col-md-' + (layout || '12')">
      <b-form-group
        :label="endName"
        invalid-feedback="請選擇完整時間段"
        :state="state"
        :class="group_class"
      >
        <date-range-picker
          ref="picker"
          :locale-data="localeData"
          show-dropdowns
          singleDatePicker
          :ranges="false"
          v-model="end_Date"
          autoApply
          :minDate="
            new Date(
              new Date(start_Date.startDate).getTime() - 24 * 60 * 60 * 1000
            )
          "
          :maxDate="future ? null : new Date(new Date().getTime())"
        >
        </date-range-picker>
      </b-form-group>
    </div>
  </div>
</template>
<style lang="scss">
.vue-daterange-picker {
  width: 100%;
}
.daterangepicker select.monthselect {
  background-color: #fff;
}
.reportrange-text {
  border-radius: 0;
  .is-invalid & {
    border-color: #dc3545;
    padding-right: calc(1.5em + 0.75rem);
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23dc3545' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e");
    background-repeat: no-repeat;
    background-position: right calc(0.375em + 0.1875rem) center;
    background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
  }
}
</style>
<script>
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import "@/assets/js/dateFormat.js";

export default {
  name: "ManageDateRangePicker",
  components: { DateRangePicker },
  props: [
    "startName",
    "endName",
    "state",
    "group_class",
    "startDate",
    "endDate",
    "future",
    "layout"
  ],
  data() {
    return {
      start_Date: {
        startDate: this.startDate
          ? new Date(this.startDate).format("yyyy-MM-dd")
          : null,
        endDate: this.startDate
          ? new Date(this.startDate).format("yyyy-MM-dd")
          : null
      },
      end_Date: {
        startDate: this.endDate
          ? new Date(this.endDate).format("yyyy-MM-dd")
          : null,
        endDate: this.endDate
          ? new Date(this.endDate).format("yyyy-MM-dd")
          : null
      },
      localeData: {
        format: "yyyy-mm-dd",
        daysOfWeek: ["日", "一", "二", "三", "四", "五", "六"],
        monthNames: [
          "1月",
          "2月",
          "3月",
          "4月",
          "5月",
          "6月",
          "7月",
          "8月",
          "9月",
          "10月",
          "11月",
          "12月"
        ]
      }
    };
  },
  watch: {
    startDate(newData) {
      if (newData == "") {
        this.start_Date.startDate = null;
        this.start_Date.endDate = null;
        this.end_Date.startDate = null;
        this.end_Date.endDate = null;
      }
    },
    start_Date() {
      this.end_Date.startDate = null;
      this.end_Date.endDate = null;
      this.updateValues();
    },
    end_Date() {
      this.updateValues();
    }
  },
  methods: {
    updateValues() {
      this.$emit("childMethod", {
        startDate: this.start_Date.startDate
          ? this.start_Date.startDate.format("yyyy-MM-dd")
          : "",
        endDate: this.end_Date.startDate
          ? this.end_Date.startDate.format("yyyy-MM-dd")
          : ""
      });
    }
  }
};
</script>
